<template>
  <div class="home" id="home">
    <vue-headful title="Standort - FF Pfaffenhofen"/>
    <Header :menu-at="0" headerTitle="Standort"/>
    <div class="container header-container">
      <h1>Unser Standort</h1>
      <p>
        Pfaffenhofen ist eine 3800 Einwohner Gemeinde und liegt im Landkreis Neu-Ulm (Bayern). 
        Insgesamt hat die Marktgemeinde 7000 Einwohner. Neben der Feuerwehr Pfaffenhofen gibt 
        es noch acht weitere Ortsteilwehren die für den Schutz der Bürger sorgen. Einsatzschwerpunkte
        sind die Staatsstraßen und Industriebetriebe. Auch überörtlich ist die Feuerwehr 
        Pfaffenhofen in Einsatzplänen vermerkt.
      </p>
    </div>
    

    <div class="text">
      <div class="container text-container">
        <h1>Unser Feuerwhergrätehaus</h1>
        <p>Seit 1748 gab es in Pfaffenhofen ein Feuerhaus, das 1822 der "Landschaft" der Herrschaft Pfaffenhofen, 
          das heißt allen zur Herrschaft gehörigen Gemeinden gehörte, die es auch zu unterhalten hatten. <br><br>
          Später, seit 1873, beschränkte sich die Gemeinschaft auf Pfaffenhofen und Volkertshofen, welche zusammen (2/3 und 1/3) den Unterhalt sowie die Kosten für Geräte trugen.</p>
      </div>
    </div>  
    
    <div class="overview">
      <div class="border"></div>
      <div class="container overview-container">
        <div class="flex-row">
          <div class="vehicle-card">
            <img src="/site/0.jpg">
            <p>Das alte Haus Nr. 52 an der Hauptstraße. Abgebrochen 1957.</p>
          </div>
          <div class="vehicle-card">
            <img src="/site/1.jpg" @click="showTlfModal()">
            <p>Ab 1957 diente der ausgebaute Stadel des alten Rathauses zur Unterbringung der Feuerwehrgeräte.</p>
          </div>
        </div>
      </div>
      <div class="border"></div>
    </div>

    <div class="text more-text">
      <div class="container text-container">
        <p>Ab 1748 wurden die Ledereimer und die übrigen Löschwerkzeuge wohl schon im alten Haus Nr. 52 an der heutigen 
          Hauptstraße in Pfaffenhofen aufbewahrt, das man zuerst "Feuerhaus" und später "Spritzenhaus" nannte, 
          und das 1957 abgebrochen wurde. 
          Ab 1957 diente der ausgebaute Stadel des alten Rathauses zur Unterbringung 
          der Feuerwehrgeräte. 
          <br><br>
          Der immer dringender werdenden Notwendigkeit eines neuen Feuerwehrgerätehauses wurde 
          dadurch Rechnung getragen, daß der Markt am 08.12.1971 die dafür notwendigen Grundstücke erwarb. Zusammen mit 
          der Firma Wilhelm Egle erwarb sie um insgesamt 200.000 DM von der eingetragenen Genossenschaft Milchwerke 
          Schwaben in Ulm das ehemalige Molkereigebäude in Pfaffenhofen (damals Molkereiweg 7, heute 17). Die Käufer 
          zahlten die Hälfte des Kaufpreises. Während Egle das Molkereigebäude mit angrenzendem Grund übernahm, bekam 
          der Markt das Eigentum an den Garagen und circa 2100 qm. Die Feuerwehr und ihr damaliger Kommandant Josef 
          Inhofer konnten nun auf ein baldiges neues Domizil hoffen. 
          <br><br>
          Am 03.11.1973 konnte der Bau unter großer Teilnahme 
          der Bevölkerung und benachbarter Feuerwehren eingeweiht werden. 1978 pflasterten die Feuerwehrleute in Eigenregie 
          rund 1.000 m² Hoffläche. Bei hochsommerlichen Temperaturen flossen dabei viele Liter Schweiß. Insgesamt wurden 
          weit über 1.000 Arbeitsstunden geleistet.</p>
       </div>
    </div>
    
    <div class="overview">
      <div class="border"></div>
      <div class="container overview-container">
        <div class="flex-row">
          <div class="vehicle-card">
            <img src="/site/2.jpg">
            <p>Das ehemalige Molkereigebäude, 1971 erworben.</p>
          </div>
          <div class="vehicle-card">
            <img src="/site/3.jpg" @click="showTlfModal()">
            <p>1988 wurde das Gebäude erweitert und umgebaut.</p>
          </div>
          <div class="vehicle-card">
            <img src="/site/4.jpg" @click="showTlfModal()">
            <p>Unser Feuerwehrgerätehaus heute.</p>
          </div>
        </div>
      </div>
      <div class="border"></div>
    </div>

     <div class="text more-text">
      <div class="container text-container">    
        <p>1988 wurde das Gerätehaus um eine weitere Fahrzeugbox erweitert und zugleich die alten Holztore durch 
          moderne, dicht schließende Rolltore ausgewechselt. Auch die betagte elektrische Heizung wurde durch eine 
          umweltfreundliche Gasheizung ausgetauscht. In Eigenarbeit errichteten die Feuerwehrmänner zudem eine kleine 
          Pflegewerkstatt für Atemschutzgeräte. Nicht unerhebliche Eigenleistungen wurden selbstverständlich auch 
          bei den gesamten Erweiterungs- und Sanierungsarbeiten erbracht. Zudem wurde der Schulungs- und 
          Aufenthaltsraum durch den Feuerwehrverein auf eigene Kosten neu ausgestattet.Zur Unterbringung des 
          Heuwehrgerätes und als Geräteraum und Lager für Ölbindemittel wurde 1989 in der südwestlichen Grundstücksecke 
          eine gebrauchte Fertiggarage aufgestellt. Der Vorplatz, sowie seitlich ein zusätzlicher Stellplatz 
          wurden wiederum in Eigenarbeit gepflastert. 
          <br><br>
          Durch die erfolgreiche Jugendarbeit ist die Mannschaft der Freiwilligen Feuerwehr ständig gewachsen. 
          Das Gerätehaus platzte nur einige Jahre später bereits wieder aus allen Nähten. Erweiterungen im Werkstattbereich, 
          die Schaffung eines ausreichenden Schulungsraumes sowie von Büro- und Lagerräumen, die Sanierung der Sanitäranlagen 
          und des Schlauchturmes waren vordringlich. Die Feuerwehr drängte darauf, dass noch im Jubiläumsjahr 1998 eine konkrete 
          Planung auf den Weg gebracht wird und entsprechende Mittel in das Investitionsprogramm und die Finanzplanung des Haushaltes 
          aufgenommen werden. Der Marktrat hat die Notwendigkeit des Vorhabens erkannt und Architekt Hermann Spiegler mit der 
          Entwurfsplanung und später auch mit der Bauabwicklung beauftragt. 
          <br><br>
          Nach der langen Phase von Planung, Zuschussantragstellung 
          und Ausschreibung der Bauleistungen konnte der erste Spatenstich am 03. Mai 2000 begangen werden. Das Richtfest wurde am 30. 
          September gefeiert. Nach zweijähriger Bauzeit waren nun auch endlich die Umbau- und Sanierungsarbeiten im Altbau abgeschlossen. 
          Am "Florianstag" (Samstag, 04. Mai 2002) erfolgte die kirchliche Segnung und offizielle Übergabe des Gebäudes und seiner 
          modernen Einrichtung an die Freiwillige Feuerwehr Pfaffenhofen. Zur Einweihung fand ein würdiger Festakt mit geladenen Gästen statt. 
          Am Tag der offenen Tür (Sonntag, 05. Mai 2002) konnte das Haus der Bevölkerung vorgestellt werden. </p>
      </div>
    </div>

    <Footer />
    <Scroll2Top />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Scroll2Top from '@/components/Scroll2Top.vue'

export default {
  name: 'home',
  components: {
    Header, Footer, Scroll2Top
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

.header-container {
  padding-top: 100px;
}


h1 {
  text-align: center;

  @include tablet {
    text-align: left;
  }
}

p {
  opacity: 0.8;
}

.border {
  border-top: 2px solid $light-0;
}

.overview {
  background: $dark;
  padding: 6px 0px;

  h1, h2, p {
    color: $light-0;
  }
}

.flex-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin-top: 40px;
  margin-bottom: 20px;
  align-items: center;
}

.vehicle-card {
  margin-bottom: 0px;
  width: 320px;

  img {
    width: 320px;
    object-fit: cover;
  }

  P {
    margin-top: 0px;
    padding: 0px 10px; 
    text-align: center;
  }
}

.more-text {
  margin: 20px 0px;
}


</style>
